import React, { useState, useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';
import axios from 'axios';
import { toast } from "react-toastify"
import { API_BASE_URL } from '../../utils/CONSTANTS';
import Header from '../../components/header';
import { canManageWireStockDelete } from '../../utils/roles';

const Wire = ({ onClose }) => {
  const [wireName, setWireName] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [saveError, setSaveError] = useState(null);
  const [wires, setwires] = useState([]);
  const canDeleteWire = canManageWireStockDelete();



  const getallwires = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/wire/names`, { withCredentials: true });
      const wirenames = response.data.names.map((item) => item.name);
      // Extract number and sort by it
      const extractNumber = (str) => {
        const match = str.match(/[\d.]+/); // grabs first numeric value
        return match ? parseFloat(match[0]) : 0;
      };

      const sortedWires = wirenames.sort((a, b) => extractNumber(a) - extractNumber(b));

      setwires(sortedWires);
    } catch (err) {
      console.log(err.message);

    }

  }
  useEffect(() => {
    getallwires();
  }, []);

  const data = [
    { id: 1, wireName: "Alpha Wire" },
    { id: 2, wireName: "Beta Wire" },
    { id: 3, wireName: "Gamma Wire" },
    { id: 4, wireName: "Delta Wire" },
  ];

  const handleSave = async () => {
    if (!wireName.trim()) {
      setSaveError('Wire name cannot be empty');
      return;
    }

    setIsSaving(true);
    setSaveError(null);

    try {
      const response = await axios.post(`${API_BASE_URL}/api/wire/save-name`, { name: wireName }, {
        withCredentials: true
      });
      if (response.status === 200) {
        toast("wire saved successfully");
        await getallwires();
      }
    } catch (error) {
      console.error('Error saving wire name:', error);
      toast('Failed to save wire name. Please try again.');

      setSaveError('Failed to save wire name. Please try again.');
    } finally {
      setIsSaving(false);
    }
  };


  const handleClose = () => {
    if (wireName.trim()) {
      if (window.confirm('You have unsaved changes. Are you sure you want to close?')) {
        onClose();
      }
    } else {
      onClose();
    }
  };
  const handledelete = async (wireName) => {
    try {
      // Use the exact endpoint from your routes file
      const response = await axios.delete(
        `${API_BASE_URL}/api/wire/deletewire/${encodeURIComponent(wireName)}`,
        { withCredentials: true }
      );

      if (response.status === 200) {
        toast.success(`Wire "${wireName}" deleted successfully`);
        await getallwires(); // Refresh the list
      }
    } catch (error) {
      console.error('Error deleting wire:', error);
      toast.error(
        error.response?.data?.message ||
        `Failed to delete wire "${wireName}". Please verify the name exists.`
      );
    }
  };

  return (
    <>
      <Header />

      <div className="p-2 max-w-[600px] mx-auto">
        <div className="bg-[#e6ffff] border border-gray-300 rounded shadow">
          {/* Header */}
          <div className="flex justify-between items-center px-2 py-1 border-b border-gray-300">
            <h2 className="text-sm font-semibold">Wire</h2>
            <button onClick={handleClose} className="p-0.5 hover:bg-gray-200 rounded">
              <FaTimes className="text-gray-600 w-3 h-3" />
            </button>
          </div>

          {/* Content */}
          <div className="p-4 space-y-4">
            <div>
              <label htmlFor="wireName" className="block text-xs font-medium text-gray-700 mb-1">
                Wire Name
              </label>
              <input
                id="wireName"
                type="text"
                value={wireName}
                onChange={(e) => setWireName(e.target.value)}
                className="w-full border rounded p-1 text-sm"
                placeholder="Enter wire name"
              />
            </div>

            {saveError && <p className="text-xs text-red-500">{saveError}</p>}

            <button
              onClick={handleSave}
              disabled={isSaving}
              className={`w-full py-1 px-2 rounded text-sm ${isSaving
                ? 'bg-gray-400 cursor-not-allowed'
                : 'bg-blue-500 text-white hover:bg-blue-600'
                }`}
            >
              {isSaving ? 'Saving...' : 'Save'}
            </button>
          </div>
        </div>

        <div className="overflow-x-auto p-4">
          <table className="table-auto border-collapse border border-gray-300 w-full">
            <thead>
              <tr className="bg-gray-200">
                <th className="border border-gray-300 px-4 py-2 text-left">Index</th>
                <th className="border border-gray-300 px-4 py-2 text-left">Wire Name</th>
                {canDeleteWire && (
                  <th className="border border-gray-300 px-4 py-2 text-left">Action</th>
                )}
              </tr>
            </thead>
            <tbody>
              {wires.map((value, index) => (
                <tr key={index} className="hover:bg-gray-100">
                  <td className="border border-gray-300 px-4 py-2">{index + 1}</td>
                  <td className="border border-gray-300 px-4 py-2">{value}</td>
                  {canDeleteWire && (
                  <td className="border border-gray-300 px-4 py-2">
                    <button onClick={() => handledelete(value)}>
                      <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="25" height="25" viewBox="0 0 24 24">
                        <path d="M 10.806641 2 C 10.289641 2 9.7956875 2.2043125 9.4296875 2.5703125 L 9 3 L 4 3 A 1.0001 1.0001 0 1 0 4 5 L 20 5 A 1.0001 1.0001 0 1 0 20 3 L 15 3 L 14.570312 2.5703125 C 14.205312 2.2043125 13.710359 2 13.193359 2 L 10.806641 2 z M 4.3652344 7 L 5.8925781 20.263672 C 6.0245781 21.253672 6.877 22 7.875 22 L 16.123047 22 C 17.121047 22 17.974422 21.254859 18.107422 20.255859 L 19.634766 7 L 4.3652344 7 z"></path>
                      </svg>
                    </button>
                  </td>
                  )}

                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default Wire;

